export default __webpack_public_path__ + "Src/Client/Error/unauthorized.html";